import React, { useEffect, useState } from "react";
import { CalendarBlank } from "@phosphor-icons/react";
import { useLang } from "../context/LanguageContext";

export default function StickyBookingBar({ onBook }) {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      onClick={onBook}
      data-testid="sticky-book-button"
      className="lg:hidden fixed bottom-4 left-4 right-4 z-40 btn-gold py-4 text-xs uppercase tracking-[0.2em] font-medium flex items-center justify-center gap-3 shadow-2xl"
    >
      <CalendarBlank size={18} weight="light" />
      {t.cta.book}
    </button>
  );
}
